const pressData = [
  {
    id: 43,
    title: "Power Women Summit 2025: On the Scene With Regina Hall, Rhea Seehorn, Olivia Munn and More | Photos",
    date: "December 4, 2025",
    source: "The Wrap",
    type: 'mixed',
    img: "/pressImgs/thewrap_2025_pwomen_cocktail.jpg",
    summary: "Stars like Uzo Aduba and Natasha Rothwell, producers like Mimi Leder, creators like Michelle Khare and so many more come together for a day of community building and educating.",
    originalUrl: "https://www.thewrap.com/2025-the-power-women-summit-event-photo-gallery/"
  },
  {
    id: 42,
    title: "Jordan Chiles’ Perfect Plan Promises to Make the DWTS Finale Unforgettable for the Whole Cast",
    date: "November 25, 2025",
    source: "Essentially Sports",
    type: 'long',
    img: "/pressImgs/essentiallysports_logo.webp",
    summary: "The two-time Olympic medalist took to her Instagram stories to reveal a massive, and we mean massive, gift hamper for the finalists, judges, and, of course, the hosts as well.",
    originalUrl: "https://www.essentiallysports.com/olympics-gymnastics-news-jordan-chiles-perfect-plan-promises-to-make-the-dwts-finale-unforgettable-for-the-whole-cast/"
  },
  {
    id: 44,
    title: "What’s In the 2025 Emmys Gift Bags? All About the Luxurious Items Every Nominee Takes Home",
    date: "September 13, 2025",
    source: "People",
    type: 'long',
    img: "/pressImgs/people-logo.png",
    summary: "Nominees and presenters have access to an exclusive gifting suite ahead of the awards show.",
    originalUrl: "https://people.com/emmys-gift-bag-what-to-know-11807468"
  },
  {
    id: 39,
    title: "What’s in the Oscars Gift Bags, and Why the Tradition Endures",
    date: "April 26, 2021",
    source: "The New York Times",
    type: 'long',
    img: "/pressImgs/New_York_Times_logo.png",
    summary: "Much will be different at this year’s awards, but stars can still lay claim to free liposuction and a getaway to French Polynesia.",
    originalUrl: "https://www.nytimes.com/2021/04/23/us/oscars-gift-bags.html"
  },
  {
    id: 40,
    title: "Inside The $205,000 Oscar 2021 Gift Bag: From A Spa Retreat To ‘Poetry For Neanderthals’",
    date: "April 22, 2021",
    source: "Forbes",
    type: 'long',
    img: "/pressImgs/forbes.png",
    summary: "The pandemic killed off a number of Hollywood traditions in the past year. The Oscar season swag bag wasn’t one of them. ",
    originalUrl: "https://www.forbes.com/sites/dawnchmielewski/2021/04/22/inside-the-200000-oscar-2021-gift-bag-from-a-spa-retreat-to-poetry-for-neanderthals/"
  },
  {
    id: 1,
    title: "See What It Looked Like Behind The Scenes At The 2018 ESSENCE Black Women In Hollywood Awards",
    date: "March 27, 2018",
    source: "ESSENCE",
    type: 'long',
    img: "/pressImgs/essence.png",
    summary: "There's nothing quite like a cute, candid photo-op and the 2018 Black Women In Hollywood crowd gave us plenty of swoon-worthy moments.",
    originalUrl: "https://www.essence.com/celebrity/candid-essence-black-women-hollywood/#1303355"
  },
  {
    id: 2,
    title: "Montgomery County Native Talks Putting Together Hollywood Gift Bags",
    date: "March 1, 2018",
    source: "CBS News",
    type: 'long',
    img: "/pressImgs/cbs_news_philly.png",
    summary: "A Montgomery County native whose job it is to assemble them spoke about what goes into building the extravagant party favors.",
    originalUrl: "https://www.cbsnews.com/philadelphia/news/montgomery-county-native-talks-putting-together-hollywood-gift-bags/"
  },
  {
    id: 3,
    title: "The queen of Oscar weekend's glitzy gift bags is a Lafayette Hill-bred woman",
    date: "February 28, 2018",
    source: "Philadelphia Magazine",
    type: 'long',
    img: "/pressImgs/Philadelphia-Inquirer-Logo.png",
    summary: "The Lafayette Hill native is the founder of the Los Angeles company Gift Bags by Rachael.",
    originalUrl: "https://www.inquirer.com/philly/columnists/elizabeth_wellington/oscar-gift-bags-rachael-honowitz-cosgrove-academy-awards-lafayette-hill-20180228.html"
  },
  {
    id: 4,
    title: "The 2018 Grammy Awards gift bag is weird, wonderful and worth over $20,000",
    date: "January 29, 2018",
    source: "Vogue Australia",
    type: 'long',
    img: "/pressImgs/grammys-2018.png",
    summary: "To ensure guests remember the night at the 2018 Grammy Awards, each of the guests will take home the ultimate gift bag.",
    originalUrl: "https://www.vogue.com.au/culture/features/the-2018-grammy-awards-gift-bag-is-weird-wonderful-and-worth-over-20000/news-story/034494405d4f99b5833d0423f43797f6"
  },
  {
    id: 5,
    title: "LA Confidential Magazine Features Gift Bags by Rachael",
    date: "February 17, 2015",
    source: "LA Confidential",
    type: 'short',
    img: "/pressImgs/la-confidential.jpeg",
    summary: "Highlighting her work in Hollywood's luxury gifting scene.",
  },
];

export default pressData;